<form method="#" action="#">
  <div class="card card-login">
      <div class="card-content">
          <div class="text-center login-header">
            <img src="assets/img/able/NewEra_ABLE_Master_Logo_CMYK.png" class="logo" alt="able+" title="able+"/>
            <h3>Two-factor authentication</h3>
      </div>

          <p class="text-center">A message with a verification code has been sent to your preferred email/contact. </p>

          <p class="text-center">Enter the code to continue.</p>

          <div class="row verify-form">
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding">
              <div class="form-group"><input type="text" value="2" class="form-control text-center"></div>
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding">
              <div class="form-group"><input type="text" value="5"  class="form-control text-center"></div>
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding">
              <div class="form-group"><input type="text" value="9"  class="form-control text-center"></div>
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding">
              <div class="form-group"><input type="text" value="1"  class="form-control text-center"></div>
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding">
              <div class="form-group"><input type="text" value="0"  class="form-control text-center"></div>
            </div>
            <div class="col-md-2 col-xs-2 col-md-offset-0 col-xs-offset-0 no-right-padding">
              <div class="form-group"><input type="text" value="0"  class="form-control text-center"></div>
            </div>
          </div>

          <p class="text-center"><a class="btn btn-success btn-fab btn-fab-mini" href="able_home.html"><i class="material-icons">done</i></a></p>

      </div>

      <div class="footer text-center">

        <div class="small dropup">
          <a href="#" class="text-gray dropdown-toggle" data-toggle="dropdown">Didn't get a verification code?</a>
          <div class="dropdown-menu verify-popup">
            <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 text-center left-col">
                <a href="#">
                <h4><i class="material-icons text-gray">refresh</i></h4>
                <p>Reset code.<br/>
                  Get a new verification code on your app
                </p>
                </a>
              </div>
              <div class="col-md-6 text-center">
                <a href="#">
                  <h4>SMS</h4>
                <p>Text me.<br/>
                  Get a new verification code as text message
                </p>
                </a>
              </div>
            </div>
            </div>
          </div>
        </div>


      </div>

  </div><!----card end------>
</form>
